export const datePattern = (format = 'normal', precision = 'YMD') => {
    switch (format) {
        case 'iso':
            return 'yyyy-MM-dd';
        case 'normal': {
            const mapPart = (part) => {
                switch (part.type) {
                    case 'literal':
                        return part.value;
                    case 'day':
                        return 'dd';
                    case 'month':
                        return 'MM';
                    case 'year':
                        return 'yyyy';
                    default:
                        return null;
                }
            };
            const parts = (new Intl.DateTimeFormat()).formatToParts(new Date()).filter((p) => {
                switch (p.type) {
                    case 'literal':
                        return true;
                    case 'day':
                        return precision.includes('D');
                    case 'month':
                        return precision.includes('M');
                    case 'year':
                        return precision.includes('Y');
                    default:
                        return false;
                }
            });
            while (parts.length > 0 && parts[0].type === 'literal') {
                parts.shift();
            }
            while (parts.length > 0 && parts[parts.length - 1].type === 'literal') {
                parts.pop();
            }
            return parts.map((p) => mapPart(p)).join('');
        }
        default:
            return 'unkown date pattern';
    }
};
